import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import { Alert, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import Button from '../Button/Button';
import { PostcodeField } from './components';
import { actions } from './redux/PostcodeActions';
import Select from 'react-select';
import './PostcodeList.scss';

const SearchButton = ({ isLoading, onPostcodeSearch, value }) => {
  const handleSearch = () => {
    return onPostcodeSearch(value);
  };
  return (
    <Button
      type="button"
      className="search-btn"
      handleClick={handleSearch}
      label="Search"
      isLoading={isLoading}
      search
    />
  );
};

const AddressList = ({ options, onSelect }) => {
  if (!options?.length) {
    return null;
  }

  return (
    <Select
      onChange={onSelect}
      options={options}
      placeholder="Please select your address from the following..."
      clearable={false}
    />
  );
};

const ErrorMessage = ({ options, isAlertVisible, onDismiss }) => {
  if (!!options?.length || !isAlertVisible) {
    return null;
  }
  return (
    <div className="not-found-alert fade in">
      <Alert bsStyle="danger" onDismiss={onDismiss}>
        No addresses were found with the given criteria.
      </Alert>
    </div>
  );
};
const PostcodeList = ({
  value,
  name,
  infoButton,
  labelSize,
  onChange,
  onGetAddress,
  onGetAddresses,
  formName,
  targetField,
  disabled,
  label,
  smFieldSize,
  searchSize,
  postcodeFieldSize,
  adjustWidth,
  onPostcodeChange,
}) => {
  const [populated, setPopulated] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const { isLoading } = useSelector((state) => state.postcode);

  const handleAlertDismiss = () => {
    setIsAlertVisible(false);
  };

  const handleAddressClear = () => {
    onChange(formName, targetField, {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postcode: '',
      country: '',
    });
    setPopulated(false);
  };

  const handlePostcodeSearch = (postcode) => {
    setClicked(true);
    return Promise.resolve(onGetAddresses(postcode)).then((resp) => {
      const options = resp?.data?.map((address) => {
        return {
          label: address.attributes.name,
          value: address.id,
        };
      });
      setAddresses(options);

      if (!options.length) {
        onChange(formName, targetField, {
          line1: '',
          line2: '',
          line3: '',
          town: '',
          county: '',
          country: '',
        });
        setIsAlertVisible(true);
      }
    });
  };

  const handleAddressSelect = (addressId) => {
    return Promise.resolve(onGetAddress(addressId.value)).then((address) => {
      if (address?.attributes) {
        onChange(formName, targetField, address?.attributes);
        setClicked(false);
      }
    });
  };

  const uppercase = (value) => value && value.toUpperCase();

  const style = ['postcode-list', adjustWidth && 'adjustWidth'];

  return (
    <div>
      <FormGroup className={style.join(' ')}>
        <Col sm={labelSize || 2}>
          <ControlLabel>
            {label}
            {infoButton}
          </ControlLabel>
        </Col>
        <Col sm={postcodeFieldSize || 3} className="address-field">
          <Field
            normalize={uppercase}
            name={name}
            type="text"
            disabled={disabled}
            component={PostcodeField}
            onPostcodeChange={onPostcodeChange}
            placeholder={'Postcode'}
          />
        </Col>
        {!disabled && (
          <Col
            sm={
              searchSize ? searchSize : 12 - (labelSize || 2) - (postcodeFieldSize || 3)
            }
            className="search-btn-container"
          >
            {populated ? (
              <Button
                type="button"
                className="search-btn"
                handleClick={handleAddressClear}
                label="Clear"
                isLoading={isLoading}
              />
            ) : (
              <SearchButton
                onPostcodeSearch={handlePostcodeSearch}
                value={value}
                isLoading={isLoading}
              />
            )}
          </Col>
        )}
      </FormGroup>

      {clicked && (
        <FormGroup>
          <Col sm={smFieldSize || 8} smOffset={labelSize || 2} className="fadein-fields">
            <div className="">
              <AddressList options={addresses} onSelect={handleAddressSelect} />
              <ErrorMessage
                options={addresses}
                isAlertVisible={isAlertVisible}
                onDismiss={handleAlertDismiss}
              />
            </div>
          </Col>
        </FormGroup>
      )}
    </div>
  );
};
export default connect(
  null,
  {
    onGetAddresses: actions.getAddresses,
    onGetAddress: actions.getAddress,
    onChange: change,
  },
)(PostcodeList);
